/* eslint okta/enforce-requirejs-names: 0, okta/no-specific-methods: 0, okta/no-specific-modules: 0 */
define(['underscore', 'handlebars'], function (underscore, Handlebars) {

  var _ = underscore.noConflict();

  _.mixin({

    resultCtx: function (object, property, context, defaultValue) {
      var value = _.isObject(object) ? object[property] : void 0;
      if (_.isFunction(value)) {
        value = value.call(context || object);
      }
      if (value) {
        return value;
      }
      else {
        return !_.isUndefined(defaultValue) ? defaultValue : value;
      }
    },

    isInteger: function (x) {
      return _.isNumber(x) && (x % 1 === 0);
    },

    template: function (source, data) {
      var template = Handlebars.compile(source);
      return data ? template(data) : function (data) { return template(data); };
    }

  });

  return _;

});



/** WEBPACK FOOTER **
 ** ./target/js/shared/util/underscore-wrapper.js
 **/